import React from "react";

interface Props {
  onExport: (type: "pdf" | "image") => void;
  disabled?: boolean;
}

const ExportButtons: React.FC<Props> = ({ onExport, disabled }) => {
  return (
    <div className="flex flex-col space-y-2">
      <button
        onClick={() => onExport("pdf")}
        disabled={disabled}
        className="w-full bg-blue-600 text-white rounded-md px-3 py-2 text-sm disabled:opacity-50"
      >
        Download as PDF
      </button>
      <button
        onClick={() => onExport("image")}
        disabled={disabled}
        className="w-full bg-emerald-600 text-white rounded-md px-3 py-2 text-sm disabled:opacity-50"
      >
        Download as Image
      </button>
    </div>
  );
};

export default ExportButtons;
